import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import {OrderSummaryDataHook} from '../../OrderSummary';
import s from './AdditionalFees.scss';
import {TotalGroup} from '../TotalGroup/TotalGroup';

export const AdditionalFees = ({shouldShowDivider}: {shouldShowDivider: boolean}) => {
  const {t} = useTranslation();
  const {additionalFees} = useControllerProps().cartStore.cartSummary;

  return (
    <div className={shouldShowDivider && additionalFees.length > 1 ? s.bottomDivider : undefined}>
      <TotalGroup
        dataHook={OrderSummaryDataHook.AdditionalFeesRoot}
        totals={additionalFees.map((fee) => ({
          title: fee.name,
          value: fee.price.formattedConvertedAmount,
          key: fee.code,
          additionalAttributes: {'data-wix-additional-fees-price': OrderSummaryDataHook.AdditionalFeesPrice},
        }))}
        title={t('cart.additionalFees')}
      />
    </div>
  );
};
